module.exports = __webpack_public_path__ + "static/media/1_en.cc8eb9bd.png";